import Vue from 'vue'

import app from './modules/app'
import user from './modules/user'
import getters from './getters'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state:{
    routes:[],
  },
  mutations:{
    initRoutes(state,data){
      // console.log('收到了commit',data);
      state.routes = data;
    },
    RESERT_DATA: (state) => {
      state.user = {
        UserInfo : {},
        token: '',
        name: '',
        avatar: '',
        roles: [],
        MenuList: [] // 菜单
      }
      state.routes = []
    }
  },
  actions: {
    // 清除数据
    setDataEmpty({ commit, state }) {
      commit('RESERT_DATA')
    }
  },
  modules: {
    app,
    user
  },
  getters
})

export default store
